import { SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";
import { TAXES_PERCENTAGES, TAXES_TYPES } from "@utils/Constants";
import { getEmailYupValidation } from "@utils/Forms";
import { generateSelectOption } from "@utils/Utils";

const SendToEmailFormConfig = {
    submit: {
        label: "Enviar"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "email",
                        "name": "emails",
                        "label": "Correo Electronico",
                        "labelSizing": {
                            "sm": 2
                        },
                        "options": generateSelectOption(TAXES_TYPES),
                        "validation": getEmailYupValidation()
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "includeImages",
                        "visibilityHiddenIf": () => true, // by default this input is hidden, will be activate by props
                        "label": "Incluir Imagenes",
                    }
                ],
            ]
        }
    ],
};


export default SendToEmailFormConfig;